import * as z from "zod";
import {
  GITHUB_APP_INSTALLATION_ERROR,
  GITHUB_APP_PENDING_INSTALLATION,
} from "../connectors/github/manifestInstallation";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const recordGithubAppInstallationSchema = z.object({
  connectedAppId: z.string(),
  installationId: z.string().regex(/^\d+$/),
});

export const recordGithubAppInstallation = mutator({
  schema: recordGithubAppInstallationSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app, installationId } }) => {
    if (app.identifier !== "githubApp")
      throw userFacingError("Not a GitHub App connector.");
    await tx.mutate.connectedApps.update({
      id: app.id,
      metadata: {
        ...app.metadata,
        [GITHUB_APP_PENDING_INSTALLATION]: installationId,
        [GITHUB_APP_INSTALLATION_ERROR]: "",
      },
    });
  },
});
